<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">افزودن کاربر</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row class="mt-16 mx-1">
            <v-spacer></v-spacer>
            <v-col cols="11" class="mt-5">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="3">
                  <v-row>
                    <v-col cols="12">
                      <v-row>
                        <div class="active-tab" v-if="activeTab == 1">
                          <v-btn fab x-small elevation="0" color="darkColor" dark class="active-tab-text">
                            1
                          </v-btn>
                        </div>
                        <v-btn v-if="activeTab > 1" fab small elevation="0" color="#3BCA79" dark>
                          <v-icon dark>mdi-check mdi-18px</v-icon>
                        </v-btn>
                        <v-btn v-if="activeTab < 1" fab small elevation="0" color="#EAEAEA" dark>
                          <v-icon color="#99979D">mdi-close mdi-18px</v-icon>
                        </v-btn>
                        <span class="text-index mt-3 mr-4 tabs-text" @click="changeStep(1)">
                          اطلاعات هویتی
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <hr :class="divider1" />
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <div class="active-tab" v-if="activeTab == 2">
                          <v-btn fab x-small elevation="0" color="darkColor" dark class="active-tab-text">
                            2
                          </v-btn>
                        </div>
                        <v-btn v-if="activeTab > 2" fab small elevation="0" color="#3BCA79" dark>
                          <v-icon dark>mdi-check mdi-18px</v-icon>
                        </v-btn>
                        <v-btn v-if="activeTab < 2" fab small elevation="0" color="#EAEAEA" dark>
                          <v-icon color="#99979D">mdi-close mdi-18px</v-icon>
                        </v-btn>
                        <span class="text-index mt-3 mr-4 tabs-text" @click="changeStep(2)">
                          اطلاعات تکمیلی
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <hr :class="divider2" />
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <div class="active-tab" v-if="activeTab == 3">
                          <v-btn fab x-small elevation="0" color="darkColor" dark class="active-tab-text">
                            3
                          </v-btn>
                        </div>
                        <v-btn v-if="activeTab > 3" fab small elevation="0" color="#3BCA79" dark>
                          <v-icon dark>mdi-check mdi-18px</v-icon>
                        </v-btn>
                        <v-btn v-if="activeTab < 3" fab small elevation="0" color="#EAEAEA" dark>
                          <v-icon color="#99979D">mdi-close mdi-18px</v-icon>
                        </v-btn>
                        <span class="text-index mt-3 mr-4 tabs-text" @click="changeStep(3)">
                          نقش ها
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <hr :class="divider3" />
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <div class="active-tab" v-if="activeTab == 4">
                          <v-btn fab x-small elevation="0" color="darkColor" dark class="active-tab-text">
                            4
                          </v-btn>
                        </div>
                        <v-btn v-if="activeTab > 4" fab small elevation="0" color="#3BCA79" dark>
                          <v-icon dark>mdi-check mdi-18px</v-icon>
                        </v-btn>
                        <v-btn v-if="activeTab < 4" fab small elevation="0" color="#EAEAEA" dark>
                          <v-icon color="#99979D">mdi-close mdi-18px</v-icon>
                        </v-btn>
                        <span class="text-index mt-3 mr-4 tabs-text" @click="changeStep(4)">
                          سطح دسترسی ها
                        </span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="mb-8">
                  <v-row>
                    <v-col cols="12" v-if="activeTab === 1">
                      <v-row class="mt-4">
                        <span class="text-index">اطلاعات هویتی</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row class="mt-1">
                        <v-col cols="4">
                          <v-text-field label="نام*" outlined dense v-model="user.firstName"
                            prepend-inner-icon="mdi-account mdi-18px" clearable v-on:keyup.enter="changeStep(2)"
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="نام خانوادگی*" outlined dense v-model="user.lastName"
                            prepend-inner-icon="mdi-account mdi-18px" clearable v-on:keyup.enter="changeStep(2)"
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="genderItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                            item-text="title" item-value="id" v-model="user.gender" label="جنسیت" autocomplete="off"
                            clearable clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-human-male-female mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field type="text" outlined id="user-brithDate" ref="dateTimeAdd" dense clearable
                            v-on:keyup.enter="changeStep(2)" @click:clear="clearBirthDate()"
                            clear-icon="mdi-close-circle-outline" v-model="tempUserBrithDate"
                            @focus="showUserBrithDate = true" @click="showUserBrithDate = true" label="تاریخ تولد"
                            prepend-inner-icon="mdi-calendar-range mdi-18px">
                            <template slot="append">
                              <v-icon @click="showUserBrithDate = true" class="calender-background ml-n3 mt-n2"
                                color="white">
                                mdi-calendar-range mdi-18px
                              </v-icon>
                            </template>
                          </v-text-field>
                          <date-picker :show="showUserBrithDate" simple :max="maxDate" v-model="user.birthDate"
                            :min="minDate" @change="userBrithDateChange()" :editable="true" format="YYYY-MM-DD"
                            display-format="jYYYY/jMM/jDD" custom-input="#userr1-brithDate"
                            @close="showUserBrithDate = false" />
                        </v-col>
                        <v-col>
                          <v-text-field label="کد ملی*" outlined maxlength="10" @keypress="isNumber($event)" dense
                            v-on:keyup.enter="changeStep(2)" v-model="user.nationalCode"
                            prepend-inner-icon="mdi-card-account-details mdi-18px" clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="شماره همراه" outlined maxlength="11" @keypress="isNumber($event)" dense
                            v-on:keyup.enter="changeStep(2)" v-model="user.phoneNumber"
                            prepend-inner-icon="mdi-phone mdi-18px mdi-flip-h" clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allOrganizationRolesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" item-value="id"
                            v-model="user.userPersonnelInfo.organizationRoleId" label="سمت*" autocomplete="off"
                            clearable clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-account-cog mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="شماره پرسنلی*" @keypress="isNumber($event)" outlined
                            v-on:keyup.enter="changeStep(2)" v-model="user.userPersonnelInfo.personnelNumber" dense
                            prepend-inner-icon="mdi-card-account-details mdi-18px" clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                            item-text="title" item-value="id" v-model="user.userCityIds" label="شهرستان*"
                            autocomplete="off" multiple chips small-chips clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-home-city mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="نام کاربری*" outlined v-model="user.userName" dense
                            v-on:keyup.enter="changeStep(2)" prepend-inner-icon="mdi-account mdi-18px" clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field outlined dense prepend-inner-icon="mdi-key mdi-18px" label="کلمه عبور*"
                            v-on:keyup.enter="changeStep(2)" clearable clear-icon="mdi-close-circle-outline"
                            :class="passwordClass" v-model="user.password" :append-icon="passwordIcon"
                            @click:append="showPassword()"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field outlined dense prepend-inner-icon="mdi-key mdi-18px" label="تکرار کلمه عبور*"
                            v-on:keyup.enter="changeStep(2)" clearable v-model="user.passwordRepeat"
                            clear-icon="mdi-close-circle-outline" :class="repeatPasswordClass"
                            :append-icon="repeatPasswordIcon" @click:append="showRepeatPassword()"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="changeStep(2)"
                            class="normal-letter-spacing">
                            بعدی
                          </v-btn>
                        </v-col>
                        <v-col cols="1" class="ml-1">
                          <v-btn text color="darkColor" class="normal-letter-spacing" @click="backToUsers()">
                            انصراف
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="activeTab === 2">
                      <v-row class="mt-4">
                        <span class="text-index">اطلاعات تکمیلی</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row class="mt-8">
                        <v-col cols="4">
                          <v-autocomplete :items="allEducationDegreesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" item-value="id" label="مدرک تحصیلی"
                            v-model="user.educationDegreeId" autocomplete="off" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-book-open-page-variant mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allHospitalsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" item-value="id" label="بیمارستان" multiple chips small-chips
                            v-model="user.userHospitalIds" autocomplete="off" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-hospital-building mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allOtherOrganizationsForOther" no-data-text="اطلاعاتی وجود ندارد"
                            dense outlined item-text="title" item-value="id" label="سازمان همکار" multiple chips
                            small-chips v-model="user.userOtherOrganizationIds" autocomplete="off" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-office-building mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field type="text" outlined id="user-brithDate" ref="dateTimeAdd" dense clearable
                            @click:clear="clearExpireDate()" clear-icon="mdi-close-circle-outline"
                            v-on:keyup.enter="changeStep(3)" v-model="tempUserExpireDate"
                            @focus="showUserExpireDate = true" @click="showUserExpireDate = true"
                            label="تاریخ انقضای حساب کاربری" prepend-inner-icon="mdi-calendar-range mdi-18px">
                            <template slot="append">
                              <v-icon @click="showUserExpireDate = true" class="calender-background ml-n3 mt-n2"
                                color="white">
                                mdi-calendar-range mdi-18px
                              </v-icon>
                            </template>
                          </v-text-field>
                          <date-picker :show="showUserExpireDate" simple :max="expireMaxDate" :min="expireMinDate"
                            @change="userExpireDateChange()" :editable="true" format="YYYY-MM-DD"
                            v-model="user.expireDate" display-format="jYYYY/jMM/jDD" custom-input="#userr1-brithDate"
                            @close="showUserExpireDate = false" />
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="ایمیل" outlined dense v-model="user.emailAddress"
                            prepend-inner-icon="mdi-email mdi-18px" clearable v-on:keyup.enter="changeStep(3)"
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allStations" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                            item-text="title" item-value="id" label="پایگاه" multiple chips small-chips
                            v-model="user.userStationIds" autocomplete="off" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-home mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field label="آدرس" outlined dense v-model="user.address"
                            v-on:keyup.enter="changeStep(3)" prepend-inner-icon="mdi-map-marker mdi-18px" clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="mt-n8">
                          <v-checkbox v-model="user.usePasswordPolicy" label="اعمال قوانین رمز عبور"></v-checkbox>
                        </v-col>
                        <v-col cols="4" class="mt-n8">
                          <v-checkbox v-model="user.forceTwoStepAuthentication"
                            label="استفاده از روش احراز هویت دو مرحله ای"></v-checkbox>
                        </v-col>
                        <v-col cols="4" class="mt-n8">
                          <v-checkbox v-model="user.forceChangePassword"
                            label="تغییر کلمه عبور در ورود بعدی"></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row class="mt-16">
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="changeStep(3)"
                            class="normal-letter-spacing mt-9">
                            بعدی
                          </v-btn>
                        </v-col>
                        <v-col cols="1" class="ml-1">
                          <v-btn text color="darkColor" class="normal-letter-spacing mt-9" @click="backToStepOne()">
                            بازگشت
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="activeTab === 3">
                      <v-row>
                        <span class="text-index">نقش ها</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-spacer></v-spacer>
                          <v-card elevation="0" class="inside-cards" height="20vh">
                            <v-card-text>
                              <v-chip-group column>
                                <v-chip label v-for="item in allUserRoles" :key="item.id">
                                  {{ item.persianTitle }}
                                  <v-icon right @click="addRoleToUserRoles(item)">mdi-plus</v-icon>
                                </v-chip>
                              </v-chip-group>
                            </v-card-text>
                          </v-card>
                          <v-spacer></v-spacer>
                        </v-col>
                      </v-row>
                      <v-row class="mt-4">
                        <span class="text-index">نقش های اتخابی</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-spacer></v-spacer>
                          <v-card elevation="0" class="inside-cards" height="20vh">
                            <v-card-text>
                              <v-chip-group column>
                                <v-chip color="darkColor" label dark v-for="item in allUserSelectedRoles"
                                  :key="item.id">
                                  {{ item.persianTitle }}
                                  <v-icon dark right @click="removeRoleFromUserRoles(item)">
                                    mdi-close
                                  </v-icon>
                                </v-chip>
                              </v-chip-group>
                            </v-card-text>
                          </v-card>
                          <v-spacer></v-spacer>
                        </v-col>
                      </v-row>
                      <v-row class="mt-3">
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="changeStep(4)"
                            class="normal-letter-spacing">
                            بعدی
                          </v-btn>
                        </v-col>
                        <v-col cols="1" class="ml-1">
                          <v-btn text color="darkColor" class="normal-letter-spacing" @click="backToStepTow()">
                            بازگشت
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-if="activeTab === 4">
                      <v-row>
                        <span class="text-index">سطح دسترسی ها</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-spacer></v-spacer>
                          <v-card elevation="0" class="inside-cards" height="20vh">
                            <v-card-text>
                              <v-chip-group column>
                                <v-chip label v-for="item in allUserPermissions" :key="item.id">
                                  {{ item.title }}
                                  <v-icon right @click="addPermissionToUserPermissions(item)">
                                    mdi-plus
                                  </v-icon>
                                </v-chip>
                              </v-chip-group>
                            </v-card-text>
                          </v-card>
                          <v-spacer></v-spacer>
                        </v-col>
                      </v-row>
                      <v-row class="mt-4">
                        <span class="text-index">سطح دسترسی های اتخابی</span>
                        <v-divider class="text-index mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-spacer></v-spacer>
                          <v-card elevation="0" class="inside-cards" height="20vh">
                            <v-card-text>
                              <v-chip-group column>
                                <v-chip color="darkColor" class="mr-3" dark label
                                  v-for="item in allUserSelectedPermissions" :key="item.id">
                                  {{ item.title }}
                                  <v-icon dark right @click="removePermissionFromUserPermissions(item)">
                                    mdi-close
                                  </v-icon>
                                </v-chip>
                              </v-chip-group>
                            </v-card-text>
                          </v-card>
                          <v-spacer></v-spacer>
                        </v-col>
                      </v-row>
                      <v-row class="mt-3">
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="addUserFunction()"
                            class="normal-letter-spacing">
                            ثبت
                          </v-btn>
                        </v-col>
                        <v-col cols="1" class="ml-1">
                          <v-btn text color="darkColor" class="normal-letter-spacing" @click="backToStepTree()">
                            بازگشت
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';

import AlertComponent from '../../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import sharedHelper from '@/Helpers/Shared';
import ShearedMixin from '@/Mixins/Shared.js';
import UserHelper from '@/Helpers/BaseInformation/UserHelper';
import AddUserHelper from '@/Helpers/BaseInformation/AddUserHelper';
import UserMixin from '@/Mixins/BaseInformation/UserMixin';
import OrganizationRoleMixin from '@/Mixins/BaseInformation/OrganizationRoleMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import EducationDegreeMixin from '@/Mixins/BaseInformation/EducationDegreeMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import RoleMixin from '@/Mixins/BaseInformation/RoleMixin';
import PermissionMixin from '@/Mixins/BaseInformation/PermissionMixin';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';

export default {
  inject: ['tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
  },
  mixins: [
    sharedHelper,
    ShearedMixin,
    UserHelper,
    UserMixin,
    AddUserHelper,
    OrganizationRoleMixin,
    CityMixin,
    EducationDegreeMixin,
    HospitalMixin,
    snackBar,
    RoleMixin,
    PermissionMixin,
    OtherOrganizationMixin,
    StationMixin,
  ],
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let currentDate = Vue.moment().format('YYYY/MM/DD');
      this.maxDate = currentDate;
      this.expireMinDate = currentDate;
      let aYearFromNow = new Date();
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 10);
      let expireMaxDate = Vue.moment(aYearFromNow).format('YYYY/MM/DD');
      this.expireMaxDate = expireMaxDate;
      this.getListOfOrganizationRolesForOther();
      this.getListOfCitysForOther();
      this.getListOfEducationDegreesForOther();
      this.getListOfHospitalsForOther();
      this.getAllRoles();
      this.getAllPermissions();
      this.getListOfOtherOrganizationsForOther();
      this.getAllStations();
    },
  },
};
</script>
<style scoped>
.active-tab {
  padding: 3px !important;
  border: 2px solid var(--dark-color) !important;
  border-radius: 50% !important;
  z-index: 9999;
}

.active-tab-text {
  font-weight: bold;
  font-size: 14px !important;
  padding-left: 2px !important;
  padding-top: 2px !important;
}

.tabs-text {
  color: #1c1b1f !important;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
}

.tab-divider-active {
  height: 60px !important;
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: 3px solid var(--dark-color) !important;
  border-radius: 100px !important;
  margin-right: 2.6vh;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.tab-divider-finish {
  height: 60px !important;
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: 3px solid #3bca79 !important;
  border-radius: 100px !important;
  margin-right: 2.6vh;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.tab-divider-notload {
  height: 60px !important;
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: 3px solid #eaeaea !important;
  border-radius: 100px !important;
  margin-right: 2.6vh;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

>>>.password .v-text-field__slot {
  font-family: 'password' !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
